// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1K9K7","calendarButtons":"ClockData_calendarButtons__2gfaf"};